import { apiService, ApiResponse } from './api';
import { Workout, WorkoutRequest } from '../types/Workout';

class WorkoutService {
  // ==================== WORKOUT MANAGEMENT ====================

  /** Create a new workout */
  async createWorkout(request: WorkoutRequest): Promise<ApiResponse<Workout>> {
    return apiService.post<Workout>('/api/workouts', request);
  }

  /** Update an existing workout */
  async updateWorkout(workoutId: number, request: WorkoutRequest): Promise<ApiResponse<Workout>> {
    return apiService.put<Workout>(`/api/workouts/${workoutId}`, request);
  }

  /** Get all workouts for a member */
  async getMemberWorkouts(memberId: number): Promise<ApiResponse<Workout[]>> {
    return apiService.get<Workout[]>(`/api/workouts/member/${memberId}`);
  }

  /** Get all workouts for a member with pagination */
  async getMemberWorkoutsPage(memberId: number, page: number = 0, size: number = 20): Promise<ApiResponse<any>> {
    return apiService.get<any>(`/api/workouts/member/${memberId}/page?page=${page}&size=${size}`);
  }

  /** Get a specific workout by ID */
  async getWorkout(workoutId: number): Promise<ApiResponse<Workout>> {
    return apiService.get<Workout>(`/api/workouts/${workoutId}`);
  }

  /** Delete a workout (soft delete) */
  async deleteWorkout(workoutId: number, memberId: number): Promise<ApiResponse<{message: string}>> {
    return apiService.delete<{message: string}>(`/api/workouts/${workoutId}/member/${memberId}`);
  }

  /** Search workouts by name for a member */
  async searchMemberWorkouts(memberId: number, workoutName: string): Promise<ApiResponse<Workout[]>> {
    return apiService.get<Workout[]>(`/api/workouts/member/${memberId}/search?workoutName=${encodeURIComponent(workoutName)}`);
  }

  // ==================== WORKOUT SHARING ====================

  /** Generate share token for a member's workout plan */
  async generateShareToken(memberId: number): Promise<ApiResponse<{token: string}>> {
    return apiService.get<{token: string}>(`/api/workouts/member/${memberId}/share`);
  }

    /** Get shared workout plan by token */
  async getSharedWorkout(token: string): Promise<ApiResponse<any>> {
    return apiService.get<any>(`/api/workouts/shared/${token}`);
  }

  /** Reorder exercises in a workout */
  async reorderExercises(workoutId: number, memberExerciseIds: number[]): Promise<ApiResponse<void>> {
    return apiService.put<void>(`/api/workout-exercises/workout/${workoutId}/reorder`, memberExerciseIds);
  }
}

export const workoutService = new WorkoutService(); 